<template>
	<svg id="Group_47658" data-name="Group 47658" xmlns="http://www.w3.org/2000/svg" width="28" height="28" viewBox="0 0 28 28">
		<g id="Ellipse_852" data-name="Ellipse 852" fill="#5858ec" stroke="#5858ec" stroke-width="1.5">
			<circle cx="14" cy="14" r="14" stroke="none" />
			<circle cx="14" cy="14" r="13.25" fill="none" />
		</g>
		<path
			id="Path_33008"
			data-name="Path 33008"
			d="M20.122,15.11l-4.533,3.944m0,0L11.056,15.11m4.533,3.943v-9.7"
			transform="translate(-1.59 -1.019)"
			fill="none"
			stroke="#fff"
			stroke-linecap="round"
			stroke-linejoin="round"
			stroke-width="2"
		/>
		<line
			id="Line_1432"
			data-name="Line 1432"
			x2="7.386"
			transform="translate(10.307 20.383)"
			fill="none"
			stroke="#fff"
			stroke-linecap="round"
			stroke-width="2"
		/>
	</svg>
</template>

<script>
export default {
	name: 'SubflowSelectionEndSvg',
};
</script>
